module.exports = __webpack_public_path__ + "static/media/24UHCHR23.43184c16.jpg";